<template>
  <module-page v-bind="pageParams" :loading="loading">
    <template>
      <div v-if="items.length === 0" class="appointment">
        <div class="appointment__blocked">
          <div class="appointment__blocked__container">
            <i class="bexsicon-calendar appointment__blocked__icon"></i>
            <div class="appointment__blocked__info">
              <span>
                <b>Nenhum compromisso agendado.</b>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <v-layout>
          <v-flex xs12>
            <v-card class="appointment__card" outlined tile>
              <ul class="appointment-list">
                <li
                  v-for="(appointment, index) in items"
                  class="appointment-list__item"
                  :key="index"
                >
                  <v-layout align-center>
                    <div class="appointment-list__item-date">
                      <span>
                        {{ appointment.day }}
                        {{ appointment.weekDay }}
                      </span>
                    </div>
                    <div>
                      <p class="appointment-list__item-hour">
                        {{ appointment.hour }}
                      </p>
                      <h5 class="appointment-list__item-title support--color">
                        {{ appointment.title }}
                      </h5>
                      <p class="appointment-list__item-place">
                        {{ `Local: ${appointment.place}` }}
                      </p>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="support--color"
                      @click="openModal(appointment)"
                      >Ver</v-btn
                    >
                  </v-layout>
                </li>
              </ul>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </template>

    <v-dialog v-model="dialog" max-width="560">
      <v-card v-if="selectedAppointment">
        <v-layout align-center column>
          <v-card-title class="title">
            <span>{{ selectedAppointment.title }}</span>
          </v-card-title>
          <v-card-text>
            <span v-if="selectedAppointment.description" class="subheading">{{
              selectedAppointment.description
            }}</span>
            <div class="appointment__appointment-container">
              <div class="appointment-list__item-date">
                <p class="appointment-list__item-hour">
                  {{ selectedAppointment.day }}
                  {{ selectedAppointment.weekDay }}
                  {{ selectedAppointment.hour }}
                </p>
                <p class="appointment-list__item-place">
                  {{ `Local: ${selectedAppointment.place}` }}
                </p>
              </div>
            </div>
          </v-card-text>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click.native="dialog = false">{{
            $t('actions.close')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </module-page>
</template>

<script>
import bus from '@/utils/bus';
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import events from '../../mixins/modules/events';
import eventsMixin from '../../mixins/modules/events';
import notificationTypes from '@/utils/notificationTypes';
import { APP, EVENTS, NOTIFICATIONS, EVENT_TYPES } from '../../utils/constants';

export default {
  name: 'appointment',
  mixins: [eventsMixin],
  components: {
    ModulePage,
    ScreenLoading,
  },
  created() {
    bus.$on('unit:change', this.getItems);
    bus.$on('unit:update', this.getItems);
    this.pageParams = this.$store.getters[APP.PAGES].appointment;
    this.getItems();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.getItems);
    bus.$off('unit:update', this.getItems);
  },
  computed: {
    items() {
      return this.$store.getters[EVENTS.GET_APPOINTMENT].filter(
        (appointment) => !appointment.notificationOnly
      );
    },
  },
  data() {
    return {
      pageParams: {},
      selectedAppointment: null,
      dialog: false,
      loading: false,
    };
  },
  methods: {
    async getItems() {
      this.loading = true;
      await Promise.all([
        this.$store.dispatch(EVENTS.FETCH_TECHNICAL_ASSISTANCE),
        this.$store.dispatch(EVENTS.FETCH_SCHEDULE),
      ]);
      this.loading = false;
    },
    openModal(appointment) {
      const notificationInfo = {
        ctx: this,
        notification: {
          id: appointment._id,
          type: notificationTypes[`EVENT`],
        },
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, notificationInfo);
      switch (appointment.typeEvent) {
        case EVENT_TYPES.technicalAssistance:
          this.$router.push({
            name: 'appointmentDetail',
            params: { ticketId: appointment.ticketId },
          });
          break;
        case EVENT_TYPES.keyDelivery:
          this.$router.push({ name: 'keyDeliverySchedule' });
          break;
        case EVENT_TYPES.inspection:
          if (this.$store.getters[EVENTS.GET_INSPECTION]) {
            this.$router.push({ name: 'inspectionDetails' });
          } else {
            this.dialog = !this.dialog;
          }
          break;
        default:
          this.dialog = !this.dialog;
          break;
      }

      this.selectedAppointment = appointment;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

>>> .v-card__text {
  padding-top: 0;
  // min-height: 100px;
  overflow-y: auto;
}
.my-enterprise-iframe {
  border: none;
  margin: 7% auto 0;
  padding: 0;
  height: 100%;
  width: 100% !important;
}

.appointment {
  &__blocked {
    display: block;
    height: 100%;
    background: #f1f1f1;
    border-radius: 4px;
    color: var(--label-color);

    &__container {
      display: flex;
      padding: 20px;
    }

    &__info {
      font-size: 11px;
      flex: 0.85;
      margin: auto 5px;
    }

    &__icon {
      flex: 0.1;
      color: var(--grey-icon-color);
      font-size: 2.5rem;
      background: #fff;
      border-radius: 50px;
      padding: 10px;
      margin-top: auto;
      margin-bottom: auto;
      margin-left: 1.2rem;
      margin-right: 0.5rem;
    }

    &__btn {
      color: #fff;
      background-color: var(--support-color) !important;
      margin: 0.3em 0;
      height: 27px;

      @include breakpoint(mobile) {
        padding: 7px !important;
      }
    }
  }
}

.appointment-list {
  display: block;
  list-style: none;

  &__item {
    display: flex;
    padding-bottom: 10px;
    margin-bottom: 10px;

    &:not(:last-child) {
      border-bottom: 1px solid #eee;
    }
  }

  &__item-date {
    flex: 40px 0 0;
    text-align: center;
    font-weight: bold;
    margin-right: 10px;
  }

  &__item-hour {
    font-weight: bold;
    margin: 0;
  }

  &__item-title {
    font-size: 14px;
  }

  &__item-place {
    font-size: 12px;
    margin: 0;
  }

  &__appointment-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/support/Appointment.vue